import { render } from "./ProductProperty.vue?vue&type=template&id=72390c3c&scoped=true&ts=true"
import script from "./ProductProperty.vue?vue&type=script&lang=ts"
export * from "./ProductProperty.vue?vue&type=script&lang=ts"

import "./ProductProperty.vue?vue&type=style&index=0&id=72390c3c&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72390c3c"]])

export default __exports__